var alignment_default = {
  "alignLeft": "yXZfY",
  "textWrapNowrap": "-pZ1k",
  "alignRight": "HudCu",
  "alignCenter": "Um-m3",
  "sizeFullWidth": "gby5G",
  "renderedInTable": "is6vx",
  "sizeOriginal": "iXtPA",
  "sizeContent": "i-Bdo",
  "sizeSmall": "Yhc01",
  "sizeSmallCenter": "-uIBI",
  "flex": "zwr-0",
  "LEFT": "m-bYL",
  "CENTER": "mtQy0",
  "RIGHT": "FNcfl",
  "AUTO": "lRgAI",
  "JUSTIFY": "tTJlO"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
